'use strict';

angular.module('mobile-apps')
	.factory('TagMain', [
		'$modal',
		'$rootScope',
		'$state',
		'$stateParams',
		'$timeout',
		'$filter',
		'SweetAlert',
		'Upload',
		'Utilities',
		'Tags',
		'TagCategories',
		'EntryMain',
		'FullscreenModal',
		'CacheDataLoad',
		function(
			$modal,
			$rootScope,
			$state,
			$stateParams,
			$timeout,
			$filter,
			SweetAlert,
			Upload,
			Utilities,
			Tags,
			TagCategories,
			EntryMain,
			FullscreenModal,
			CacheDataLoad
	) {

			var factory = {};

			factory._metadataFields = [
				'bundleVersion',
				'deviceLanguageLong',
				'deviceModel',
				'operatingSystem',
				'platform',
				'resolution',
				'isBlank'
			];

			factory._adjustingWidth = false;
			factory.tag = null;
			factory.tags = {};
			factory.tagUpdatedAt = null;
			factory.tagIdsArray = [];
			factory.screenshotIndex = 0;
			factory.filterFields = [
				{
					name: 'Language',
					value: 'deviceLanguageLong',
					selected: null,
					compareFunction: function(value, compareValue, flexibleMatch) {
						if (value === compareValue) {
							return true;
						}

						if (!flexibleMatch) {
							return false;
						}

						// If we do a flexibleMatch we compare only the first
						// part of the language. In this case "de-de" would
						// for example match "de", "de-at", "de-ch", ...
						var splitValue = value.split('-');
						var splitCompareValue = compareValue.split('-');

						if (splitValue.length !== 0 && splitCompareValue.length !== 0) {
							// Check if the short language matches
							return splitValue[0] === splitCompareValue[0];
						}

						return false;
					}
				},
				{
					name: 'Version',
					value: 'bundleVersion',
					selected: null
				},
				{
					name: 'Device',
					value: 'deviceModel',
					selected: null
				},
				{
					name: 'OS',
					value: 'operatingSystem',
					selected: null
				},
				{
					name: 'Resolution',
					value: 'resolution',
					findFunction: function(value) {
						if (!value || !angular.isString(value)) {
							return {};
						}
						var values = value.split('x');
						return {
							width: parseInt(values[0]),
							height: parseInt(values[1])
						};
					},
					valueGenerator: function(data) {
						return data.width + 'x' + data.height;
					},
					selected: null
				},
				{
					name: 'Blank',
					value: 'isBlank',
					selected: null
				}

			];

			factory.filterOptions = {};
			factory.tagCategories = {};

			/**
			 * Loads the tag with the given tag id
			 */
			factory.loadTag = function(tagId, forceRefresh, cb) {
				var me = this;

				me.getTag(tagId, forceRefresh, function(err, tag) {
					if (err) {
						me.tag = undefined;
						return cb(err);
					}

					me.tag = me._prepareTag(tag);

					me.screenshotIndex = 0;
					me.filterOptions = me._getFilterOptions(tag);


					if (tag._screenshots.length !== 0) {

						if(me.filterOptions.isBlank.includes(true)) {
							tag._screenshots.sort(function(screenshot) {
								return screenshot.metaData.isBlank ? -1: 1;
							});
						}

						// Set the latest screenshot as active
						me.screenshotIndex = tag._screenshots.length - 1;
					}

					me.setFiltersByScreenshotIndex(me.screenshotIndex);

					me.tagUpdatedAt = new Date(tag.updatedAt).toLocaleDateString();

					cb(null, tag);
				});
			};


			/**
			 * Get the tag with the given tag id
	         */
			factory.getTag = function(tagId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(tagId, callback) {
					Tags.get({
						mobileAppId: $stateParams.mobileAppId,
						tagId: tagId
					}, function(data) {
						callback(null, data);
					}, function(err) {
						callback(err);
					});
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'singleTag', tagId, forceRefresh,
					function(err, tag) {
						if (err) {
							return cb(err);
						}

						cb(null, tag);
					}
				);
			};


			/**
			 * Loads the tags of the given appId
			 */
			factory.loadTags = function (appId, forceRefresh, cb) {
				var me = this;

				var getModelData = function(appId, callback) {
					Tags.list(
						{
							mobileAppId: appId
						}, function(data) {
							callback(null, data);
						}, function(err) {
							callback(err);
						}
					);
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'allTags', appId, forceRefresh,
					function(err, tags) {
						if (err) {
							me.tags = {};
							me.tagIdsArray.length = 0;
							return cb(err);
						}

						me.tags = {};

						if (tags) {
							tags.forEach(function(tag) {
								me.tags[tag._id] = me._prepareTag(tag);
							});
						}

						var tagsArray = me._getTagArray();
						me.tagIdsArray = tagsArray.map(function(tag) { return tag._id; });

						cb(null, me.tags);
					}
				);

			};


			/**
			 * Prepares a tag to be displayed correctly by adding additional
			 * properties
			 * @param tag The tag to prepare
			 * @private
			 */
			factory._prepareTag = function(tag) {
				tag._orderTime = new Date(tag.created).getTime();

				if (tag.orderOffset) {
					tag._orderTime += tag.orderOffset;
				}

				return tag;
			};


			/**
			 * Returns the tags as array sorted by updated date
			 */
			factory._getTagArray = function () {
				var me = this;

				// Get a sorted list of tags
				var tagArray = [];
				for (var tagId in me.tags) {
					tagArray.push(me.tags[tagId]);
				}

				var returnData = tagArray.sort(function(a, b){
					return a.updatedAt > b.updatedAt;
				});

				return returnData;
			};


			/**
			 * Changes the location of the given tag in the list
			 */
			factory.moveTag = function(tag, direction, cb) {
				var me = this;

				// Get the tags in the current order
				var sortedTags = [];
				me.tagIdsArray.forEach(function(tagId) {
					sortedTags.push(me.tags[tagId]);
				});
				sortedTags = $filter('orderBy')(sortedTags, '_orderTime');

				// Get the current index of the tag we want to move
				var index;
				for (var i=0;i<sortedTags.length;i++) {
					if (sortedTags[i]._id === tag._id) {
						index = i;
						break;
					}
				}

				// Check if the entry can get moved in the direction it should
				if (index === 0 && direction === 'up') {
					// Is already the first
					return cb(null, tag);
				} else if (index === (sortedTags.length-1) && direction === 'down') {
					// Is already the last
					return cb(null, tag);
				}

				// Save the current value that we can reset it in the case
				// it does not save it correctly
				var oldOrderOffset = tag.orderOffset;
				var newOrderTime = 0;

				if (direction === 'up') {
					// Get the previous tag and make the order time of the
					// current tag smaller to be listed before
					var prevTag = sortedTags[index - 1];

					if (index - 2 < 0) {
						// There is no tag above the previous one so make it
						// simply much smaller
						newOrderTime = prevTag._orderTime - 1000000;
					} else {
						// There is a tag before the previous one so position
						// the new one in the middle of both
						var prevTag2 = sortedTags[index - 2];
						newOrderTime = prevTag._orderTime - (prevTag._orderTime - prevTag2._orderTime) / 2;
					}

					tag._orderTime = newOrderTime;
					tag.orderOffset = newOrderTime - new Date(tag.created).getTime();
				} else if (direction === 'down') {
					// Get the next tag and make the order time of the
					// current tag larger to be listed after
					var nextTag = sortedTags[index + 1];

					if (index + 2 > (sortedTags.length-1)) {
						// There is no tag bellow the next one so make it
						// simply much larger
						newOrderTime = nextTag._orderTime + 1000000;
					} else {
						// There is a tag after the next one so position
						// the new one in the middle of both
						var nextTag2 = sortedTags[index + 2];
						newOrderTime = nextTag._orderTime + (nextTag2._orderTime - nextTag._orderTime) / 2;
					}

					tag._orderTime = newOrderTime;
					tag.orderOffset = newOrderTime - new Date(tag.created).getTime();
				}

				// save the updated tag
				tag.$update(function (response) {
					$rootScope.$broadcast('tagsChanged');
					cb(null, response);
				}, function (errorResponse) {
					tag.orderOffset = oldOrderOffset;
					cb(errorResponse);
				});

			};


			/**
			 * Sets the given screenshot as active
			 */
			factory.setScreenshotAsActive = function(screenshot) {
				var me = this;

				if (!me.tag || !me.tag._screenshots || !angular.isArray(me.tag._screenshots) || me.tag._screenshots.length === 0) {
					return;
				}

				// Go through all the screenshots of the tag and set the given
				// one as active once found
				for (var i=0;i<me.tag._screenshots.length;i++) {
					if (me.tag._screenshots[i]._id === screenshot._id) {
						me.screenshotIndex = i;
					}
				}
			};


			/**
			 * Sets the filters according to the index of the given screenshot
			 */
			factory.setFiltersByScreenshotIndex = function(index) {
				var me = this;

				if (!me.tag || !me.tag._screenshots ||
					!angular.isArray(me.tag._screenshots) ||
					me.tag._screenshots.length === 0 ||
					me.tag._screenshots.length <= index
				) {
					return;
				}

				var screenshot = me.tag._screenshots[index];

				me.setFiltersByScreenshot(screenshot);
			};


			/**
			 * Sets the filters according to the given screenshot
			 */
			factory.setFiltersByScreenshot = function(screenshot) {
				var me = this;

				me.filterFields.forEach(function(filterData) {
					filterData.selected = me.getFilterFieldData(filterData, screenshot);
				});
			};


			/**
			 * Checks if the stateParams contains filter information. If any
			 * get found it applies the and returns the screenshots that match.
			 */
			factory.getScreenshotsFromStateParams = function(flexibleMatch) {
				var me = this;

				var language;
				if ($stateParams.hasOwnProperty('languageId')) {
					if (EntryMain.languages.hasOwnProperty($stateParams.languageId)) {
						language = EntryMain.languages[$stateParams.languageId].name;
					}
				}

				if ($stateParams.hasOwnProperty('mainFilter')) {
					var mainFilterField;
					me.filterFields.forEach(function(filterField) {
						// If there is a value in the stateParams for the
						// current field use it to filter by it
						if ($stateParams.hasOwnProperty(filterField.value)) {
							filterField.selected = $stateParams[filterField.value];
						}

						// We only use the current language as filter if the
						// language is not the mainFilter. Because then the user
						// selection takes precedence.
						if ($stateParams.mainFilter !== 'deviceLanguageLong' && filterField.value === 'deviceLanguageLong') {
							filterField.selected = language;
						}

						// Store the mainFilterField when we come across it
						if (filterField.value === $stateParams.mainFilter) {
							mainFilterField = filterField;
						}
					});
					return me.getScreenshotsFromFilter(mainFilterField, flexibleMatch);
				}

				return [];
			};


			/**
			 * Returns the screenshots of the current tag which match the filters
			 * as good as possible
      		 */
			factory.getScreenshotsFromFilter = function(mainFilterField, flexibleMatch) {
				var me = this;

				if (!me.tag || !me.tag._screenshots || !angular.isArray(me.tag._screenshots) || me.tag._screenshots.length === 0) {
					return [];
				}

				// Get all the current filter values
				var filterFieldsCopy = me.filterFields.slice();

				// Check if we have a mainFilterField for which finding a match is most important
				if (mainFilterField) {
					// Bring the mainFilterField in the first place
					var filterFieldOrder = filterFieldsCopy.map(function(field) { return field.value; });
					var mainFieldIndex = filterFieldOrder.indexOf(mainFilterField.value);
					if (mainFieldIndex !== -1) {
						filterFieldsCopy.splice(mainFieldIndex, 1);
						filterFieldsCopy.unshift( mainFilterField );
					}
				}

				var screenshots  = me.tag._screenshots;

				// Apply all the filters unless a filter does not return a result
				for (var i=0;i<filterFieldsCopy.length;i++) {
					var filterField = filterFieldsCopy[i];
					var newScreenshots = me._filterScreenshots(screenshots, filterField, flexibleMatch);
					if (newScreenshots.length !== 0) {
						// If we got a result we apply the filter
						screenshots = newScreenshots;
					}
				}

				return screenshots;
			};


			/**
			 * Returns only the screenshots which match the filter
			 */
			factory._filterScreenshots = function(screenshots, filterField, flexibleMatch) {
				var me = this;

				// Get the values we have to filter for
				var filterValues = {};
				if (filterField.hasOwnProperty('findFunction')) {
					filterValues = filterField.findFunction(filterField.selected);
				} else {
					filterValues[filterField.value] = filterField.selected;
				}

				// Check if we have any values to filter by else return directly
				if (Object.keys(filterValues).length === 0) {
					return screenshots;
				}

				var returnData = [];
				screenshots.forEach(function(screenshot) {
					for (var propertyName in filterValues) {
						if (!screenshot.metaData.hasOwnProperty(propertyName)) {
							return;
						}
						if (filterField.hasOwnProperty('compareFunction')) {
							if (!filterField.compareFunction(screenshot.metaData[propertyName], filterValues[propertyName], flexibleMatch)) {
								return;
							}
						} else if (screenshot.metaData[propertyName] !== filterValues[propertyName]) {
							return;
						}
					}
					returnData.push(screenshot);
				});

				return returnData;
			};


			/**
			 * Returns the value the screenshot has set for the given fieldData
			 */
			factory.getFilterFieldData = function(fieldData, screenshot) {
				if (fieldData.hasOwnProperty('valueGenerator')) {
					return fieldData.valueGenerator(screenshot.metaData);
				} else {
					return screenshot.metaData[fieldData.value];
				}
			};


			/**
			 * Uses the metadata of the currently loaded tag to create the
			 * different filter options
			 */
			factory._getFilterOptions = function(tag) {
				var me = this;

				var returnData = {};

				if (!tag || !tag._screenshots) {
					return returnData;
				}

				// Pregenerate the object which will hold the values that we
				// do not have to check every time bellow if it already exists or
				// not
				me.filterFields.forEach(function(filterData) {
					returnData[filterData.value] = [];
				});

				// Get the all the values from the screenshots for the
				// different fields
				me.filterFields.forEach(function(filterData) {
					tag._screenshots.forEach(function(screenshot) {
						var fieldValue = me.getFilterFieldData(filterData, screenshot);
						var fieldName = filterData.value;
						if (fieldValue!== undefined && returnData[fieldName].indexOf(fieldValue) === -1) {
							returnData[fieldName].push(fieldValue);
						}
					});
				});

				return returnData;
			};


			/**
			 * Creates a tag with the given name
			 */
			factory.createTag = function(tag, cb) {
				var newTag = new Tags({name: tag.name});
				if(tag.category){
					newTag.category = tag.category;
				}
				newTag.mobileApp = $stateParams.mobileAppId;

				// Redirect after save
				newTag.$save(function (response) {
					$rootScope.$broadcast('tagsChanged');
					cb(null, response);
				}, function (errorResponse) {
					cb(errorResponse);
				});
			};


			/**
			 * Removes the tag with the given id
			 */
			factory.removeTag = function(tagId, cb) {
				Tags.remove(
					{
						mobileAppId: $stateParams.mobileAppId,
						tagId: tagId
					},
					function success (response) {
						$rootScope.$broadcast('tagsChanged');
						cb(null, response);
					}, function failure (errResponse) {
						cb(errResponse);
					}
				);
			};


			/**
			 * Updates the name of the tag
			 */
			factory.updateTag = function(tagId, name, categoryName, cb) {
				var me = this;

				if (!me.tags.hasOwnProperty(tagId)) {
					return cb('Tag does not exist');
				}

				var tag = me.tags[tagId];

				var oldTagName = tag.name;

				tag.name = name;
				tag.category = categoryName;

				tag.$update(function (response) {
					$rootScope.$broadcast('tagsChanged');
					$rootScope.$broadcast('entriesChanged');
					cb(null, response);
				}, function (errorResponse) {
					tag.name = oldTagName;
					cb(errorResponse);
				});
			};


			// Screenshot - Navigation

			/**
			 * Returns if the current index is the first one
			 */
			factory.isCurrentFirstScreenshot = function() {
				var me = this;
				return me.screenshotIndex === 0;
			};


			/**
			 * Returns if the current index is the last one
			 */
			factory.isCurrentLastScreenshot = function() {
				var me = this;
				if (me.tag && me.tag._screenshots && me.screenshotIndex < (me.tag._screenshots.length - 1)) {
					return false;
				}
				return true;
			};


			/**
			 * Goes to next screenshot
			 */
			factory.goToNextScreenshot = function() {
				var me = this;
				if (!me.isCurrentLastScreenshot()) {
					me.screenshotIndex++;
					me.setFiltersByScreenshotIndex(me.screenshotIndex);
				}
			};


			/**
			 * Goes to previous screenshot
			 */
			factory.goToPreviousScreenshot = function() {
				var me = this;
				if (!me.isCurrentFirstScreenshot()) {
					me.screenshotIndex--;
					me.setFiltersByScreenshotIndex(me.screenshotIndex);
				}
			};



			// Tag Navigation

			/**
			 * Returns if the current tag is the first one
			 */
			factory.isCurrentFirstTag = function() {
				var me = this;

				if (me.tagIdsArray.length !== 0 && me.tag && me.tagIdsArray[0] === me.tag._id) {
					return true;
				}

				return false;
			};


			/**
			 * Returns if the current tag is the last one
			 */
			factory.isCurrentLastTag = function() {
				var me = this;

				var numTags  = me.tagIdsArray.length;
				if (numTags !== 0 && me.tag && me.tagIdsArray[numTags-1] === me.tag._id) {
					return true;
				}

				return false;
			};


			/**
			 * Goes to the next tag
			 */
			factory.goToNextTag = function () {
				var me = this;

				if (!me.isCurrentLastTag()) {
					var index = me.tagIdsArray.indexOf(me.tag._id);
					var nextTagId = me.tagIdsArray[index+1];
					$state.go('.', {
						tagId: nextTagId
					});
				}
			};


			/**
			 * Goes to the previous tag
			 */
			factory.goToPreviousTag = function () {
				var me = this;

				if (!me.isCurrentFirstTag()) {
					var index = me.tagIdsArray.indexOf(me.tag._id);
					var nextTagId = me.tagIdsArray[index-1];
					$state.go('.', {
						tagId: nextTagId
					});
				}
			};


			/**
			 * Opens the given screenshot fullscreen
			 */
			factory.showFullscreenScreenshot = function(fileDetails, languageEntryKey) {
				$modal.open({
					templateUrl: 'modules/mobile-apps/views/show-image.client.view.html',
					controller: 'ShowImageController',
					size: 'lg',
					resolve: {
						entryKey: function() {
							return languageEntryKey;
						},
						file: function () {
							return fileDetails;
						}
					}
				});
			};


			/**
			 * Returns the currently active screenshot
			 */
			factory.getActiveScreenshot = function() {
				var me = this;

				if (me.tag && me.tag.hasOwnProperty('_screenshots') && me.screenshotIndex < me.tag._screenshots.length) {
					return me.tag._screenshots[me.screenshotIndex];
				}

				return undefined;
			};


			/**
			 * Opens the currently active screenshot fullscreen
			 * @param entryKey Optional key which should be highlighted
			 */
			factory.openFullscreenScreenshot = function(entryKey) {
				var me = this;

				if (me.tag && me.tag.hasOwnProperty('_screenshots') && me.screenshotIndex < me.tag._screenshots.length) {

					var scopeData = $rootScope.$new();
					scopeData.TagMain = me;
					scopeData.entryKey = entryKey;
					scopeData.screenshotScale = 1;

					var options = {
						templateUrl: 'modules/mobile-apps/views/fullscreen-screenshot.client.view.html'
					};


					// Sets screenshotScale factor depending on given option
					scopeData.setScale = function(option) {
						// Multiplicator to be able bring it back into negative
						// space in case we display image in original resolution.
						var postMultiplicator = 1;

						if (option === 'toggleOriginal') {
							if (scopeData.screenshotScale < 0) {
								scopeData.screenshotScale = 1;
							} else {
								scopeData.screenshotScale = -1;
							}
						} else if (option === 'smaller') {
							if (scopeData.screenshotScale < 0) {
								// Scale relative to original resolution
								postMultiplicator = -1;
								scopeData.screenshotScale = Math.abs(scopeData.screenshotScale);
							}
							scopeData.screenshotScale /= 1.1;
						} else if (option === 'larger') {
							if (scopeData.screenshotScale < 0) {
								// Scale relative to original resolution
								postMultiplicator = -1;
								scopeData.screenshotScale = Math.abs(scopeData.screenshotScale);
							}
							scopeData.screenshotScale *= 1.1;
						} else if (option === 'fit') {
							scopeData.screenshotScale = 1;
						} else if (option === 'image') {
							scopeData.screenshotScale = -1;
						}

						scopeData.screenshotScale *= postMultiplicator;
					};


					// Callback to be called whenever a key gets pressed
					var keyDownCallback = function(e){
						// Wrap in timeout to be sure that digest cycle
						// runs afterwards to update the displayed data
						$timeout(function() {
							if (e.key === 'ArrowLeft') {
								scopeData.TagMain.goToPreviousTag();
							} else if (e.key === 'ArrowRight') {
								scopeData.TagMain.goToNextTag();
							} else if (e.key === 'ArrowUp') {
								scopeData.TagMain.goToPreviousScreenshot();
							} else if (e.key === 'ArrowDown') {
								scopeData.TagMain.goToNextScreenshot();
							}
						});
					};

					// Listen to all keydown events while the modal is open
					$(document).keydown(keyDownCallback);

					FullscreenModal.open(scopeData, options).result.then(function (selectedItem) {
						$(document).off('keydown', keyDownCallback);
					}, function () {
						$(document).off('keydown', keyDownCallback);
					});


				}
			};



			/**
			 * Depending on the currently loaded data it adjusts the width of the
			 * sidebar
			 */
			factory.adjustSidebarWidth = function() {
				var me = this;

				// If there are multiple requests in a short amount of time
				// we only process one of them with the latest data to avoid
				// unnecessary resizing
				if (me._adjustingWidth === true) {
					return;
				}

				me._adjustingWidth = true;

				$timeout(function() {
					if ($stateParams.hasOwnProperty('tagId') && $stateParams.tagId &&
						me.tag && me.tag._screenshots &&
						me.tag._screenshots.length > me.screenshotIndex) {
						var data = me.tag._screenshots[me.screenshotIndex];

						me.setColumsImageDependent(data.metaData);
					} else {
						me.setColumsImageDependent();
					}
					me._adjustingWidth = false;
				}, 200);
			};


			/**
			 * Calculates a new width/height to fit in the given bouding box
			 * by trying to use as much as the height as possible
			 * @param inputData current width/height
			 * @param boxData the max width/height
			 * @returns {{width: *, height: *}}
			 */
			factory._calculateFixBoxDimensions = function(inputData, boxData) {
				// Get the input values
				var returnWidth = inputData.width;
				var returnHeight = inputData.height;

				// Scale width/height to fit into the given bounding box
				if (returnHeight > boxData.height) {
					returnWidth *= boxData.height/returnHeight;
					returnHeight = boxData.height;
				}
				if (returnWidth > boxData.width) {
					returnHeight *= boxData.width/returnWidth;
					returnWidth = boxData.width;
				}

				return {
					width: returnWidth,
					height: returnHeight
				};
			};



			/**
			 * Sets the size of the columns so that the image can get displayed
			 * as large as possible by not using up more then 50% of the available
			 * width and 100% of available height.
			 */
			factory.setColumsImageDependent = function (imageData) {
				if (!$rootScope.isLeftSideResizing) {
					var me = this;

					if (!imageData) {
						// If no imageData given remove all the special width styles
						$('.side-content, .entry-detail-content').css({ 'width': '' });
						$('.main-content').css({ 'width': '', 'margin-left': '' });
						return;
					}

					var windowWidth = document.body.clientWidth;
					var maxImageWidth = (windowWidth / 2) - 65;

					var maxResolution = {
						width: maxImageWidth,
						height: $('.side-content').height()
					};

					// Calculate the display resolution of the image to fit in the
					// allowed space without keeping the same dimensions
					var displayImageResolution = me._calculateFixBoxDimensions(imageData, maxResolution);

					// Set the width of the columns according the calculated dimensions
					// of the image
					if (displayImageResolution.width <= maxImageWidth) {
						// Set the size of the sidecontent to the image size
						if ($rootScope.isDetailViewOpened) {
							var leftSideContentWidth = displayImageResolution.width + 63;
							var fullMainContentWidth = windowWidth - leftSideContentWidth;
							var middleSideWidth = fullMainContentWidth * 0.65;
							var rightSideWidth = fullMainContentWidth * 0.35;
							$('.side-content').css({ 'width': leftSideContentWidth + 'px' });
							$('.main-content').css({ 'width': middleSideWidth + 'px', 'margin-left': leftSideContentWidth + 'px' });
							$('.entry-detail-content').css({ 'width': rightSideWidth + 'px' });
						} else {
							var sidecontentWidth = displayImageResolution.width + 63;
							var maincontentWidth = windowWidth - sidecontentWidth;
							$('.side-content').css({ 'width': sidecontentWidth + 'px' });
							$('.main-content').css({ 'width': maincontentWidth + 'px', 'margin-left': sidecontentWidth + 'px' });
						}
					} else {
						// Set the size of the sidecontent to the max size which is 50%
						if ($rootScope.isDetailViewOpened) {
							$('.side-content, .entry-detail-content').css({ 'width': '28.5%' });
							$('.main-content').css({ 'width': '43%', 'margin-left': '28.5%' });
						} else {
							$('.side-content').css({ 'width': '50%' });
							$('.main-content').css({ 'width': '50%', 'margin-left': '50%' });
						}
					}
				}
			};


			factory.setScreenshots = function(screenshots) {
				var me = this;

				if (screenshots && angular.isArray(screenshots) && screenshots.length !== 0) {
					var index = screenshots.length - 1;
					// If any screenshots got found update the filters
					me.setFiltersByScreenshot(screenshots[index]);
					me.setScreenshotAsActive(screenshots[index]);
					me.adjustSidebarWidth();
				}
			};



			// -----------------------------------------------------
			//                   UPLOAD SCREENSHOT
			// -----------------------------------------------------

			/**
			 * Success callback for screenshot upload
			 */
			var successCallbackUploadScreenshot = function (response) {
				var me = factory;

				Utilities.loadingUiModal('close');

				me.loadTag(me.tag._id, true, function(err, tag) {
					if (!err) {
					    $rootScope.$broadcast('entriesChanged');

						// Change the size of the sidebar to match the new screenshot
						me.adjustSidebarWidth();

						// Update the url
						var filterParameters = {
							deviceLanguageLong: response.config.data.deviceLanguageLong,
							bundleVersion: response.config.data.bundleVersion,
							resolution: undefined,
							mainFilter: 'deviceLanguageLong'
						};

                        $state.reload();
					}
				});

				var text = 'Screenshot "' + response.config.file.name + '" got uploaded successfully.';
				$timeout(function() {
					SweetAlert.swal(
						{
							title: 'Success!',
							text: text,
							html: true,
							type: 'success',
							showCancelButton: false
						},
						function (isConfirm) {}
					);
				}, 250);
			};


			/**
			 * Error callback for screenshot upload
			 */
			var errorCallbackUploadScreenshot = function (response) {
				Utilities.loadingUiModal('close');

				$timeout(function() {
					SweetAlert.swal(
						{
							title: 'Failure!',
							text: 'Failed to upload : ' + response.config.file.name,
							html: true,
							type: 'error',
							showCancelButton: false
						},
						function (isConfirm) {}
					);
				}, 150);
			};


			/**
			 * Uploads the screenshot
			 */
			var uploadScreenshot = function (file, properties) {
				var me = factory;

				if (file && properties) {
					var url = '/v1/projects/' + $stateParams.mobileAppId + '/tags/' + me.tag._id + '/uploadScreenshot';

					Utilities.loadingUiModal('open');

					Upload.upload({
							url: url,
							file: file,
							data: properties
						})
						.then(successCallbackUploadScreenshot)
						.catch(errorCallbackUploadScreenshot);
				}
			};


			/**
			 * Opens modal for screenshot upload
			 */
			factory.uploadScreenshotModal = function(files) {

				var me = this;

				// Gets called also before the files get selected so we ignore
				// all requests without any
				if (!files || files.length === 0) {
					return;
				}

				// Check first if the file is an image
				var file = files[0];
				if (!file.name.match(/.*\.(jpg|jpeg|png)$/)) {
					$timeout(function() {
						SweetAlert.swal(
							{
								title: 'Wrong file type!',
								text: 'We only support jpg and png at the moment. Please get in touch with us if you have more questions.',
								type: 'warning',
								showCancelButton: false
							}
						);
					}, 150);
					return;
				}

				var modalInstance = $modal.open({
					templateUrl: 'modules/mobile-apps/views/upload-screenshot-modal.client.view.html',
					controller: 'UploadScreenshotModalController',
					size: 'md',
					resolve: {
						uploadInfo: function() {
							return {
								file: file
							};
						}
					}
				});

				modalInstance.result.then(function (properties) {

					// Get the name of the currently loaded tag and
					// add it to the request
					me.loadTag($stateParams.tagId, false,
						function(err, tag) {
							if (err) {
								errorCallbackUploadScreenshot(null, null, null, {file: file});
								return;
							}

							// Add the tag
							properties.screenTag = tag.name;

							uploadScreenshot(file, properties);
						}
					);

				});
			};


			// -----------------------------------------------------
			//                   TAG CATEGORIES
			// -----------------------------------------------------

			/**
			 * Get the tag category with the given tag category id
	         */
			factory.getTagCategory = function(tagCategoryId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(tagCategoryId, callback) {
					TagCategories.get({
						mobileAppId: $stateParams.mobileAppId,
						tagCategoryId: tagCategoryId
					}, function(data) {
						callback(null, data);
					}, function(err) {
						callback(err);
					});
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'singleTagCategory', tagCategoryId, forceRefresh,
					function(err, tag) {
						if (err) {
							return cb(err);
						}

						cb(null, tag);
					}
				);
			};


			/**
			 * Loads the tag categories of the given appId
			 */
			factory.loadTagCategories = function (appId, forceRefresh, cb) {
				var me = this;

				var getModelData = function(appId, callback) {
					TagCategories.list(
						{
							mobileAppId: appId
						}, function(data) {
							callback(null, data);
						}, function(err) {
							callback(err);
						}
					);
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'allTagCategories', appId, forceRefresh,
					function(err, tagCategories) {
						if (err) {
							me.tagCategories = {};
							me.tagCategoriesIdsArray.length = 0;
							return cb(err);
						}

						me.tagCategories = {};

						if (tagCategories) {
							tagCategories.forEach(function(tagCategory) {
								me.tagCategories[tagCategory.name] = tagCategory;
							});
						}

						var tagCategoriesArray = me._getTagArray();
						me.tagCategoriesIdsArray = tagCategoriesArray.map(function(tagCategory) { return tagCategory.name; });

						cb(null, me.tagCategories);
					}
				);

			};

			/**
			 * Creates given tag categories
			 */
			factory.createTagCategories = function(tagCategories) {
				TagCategories.create({mobileAppId: $stateParams.mobileAppId, tagCategories: tagCategories});
			};

			/**
			 * Removes given tag categories
			 */
			factory.removeTagCategories = function(tagCategories, cb) {
				TagCategories.remove(
					{
						mobileAppId: $stateParams.mobileAppId,
						tagCategories: tagCategories
					},
					function success (response) {
						cb(null, response);
					}, function failure (errResponse) {
						cb(errResponse);
					}
				);
			};


			return factory;
		}
	]);
